// Libs
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
// Components
import OnlyReadField from '../OnlyReadField/OnlyReadField';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Config
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
// Selectors
import { selectSelectedSubModule } from 'components/Modules/selectors';
// Capabilities
import { resolvePaymentOrderInvoiceContext } from 'core/ElementViewBuilder/views/Billing/Payment/paymentOrderCapabilities';
import { canOpenContractorPaymentSummary } from 'core/ElementViewBuilder/views/Billing/Payment/paymentSummaryCapabilities';

const SummaryButton = styled.button`
	appearance: none;
	background: transparent;
	border: 0;
	border-radius: 3px;
	color: inherit;
	cursor: pointer;
	font: inherit;
	font-weight: 600;
	padding: 0 2px;
	text-decoration: underline;
	text-underline-offset: 2px;

	&:focus-visible {
		outline: 2px solid currentColor;
		outline-offset: 2px;
	}
`;

export const isPaymentSummaryRow = (rowData, profile) => {
	const recipientEntityId = profile?.entity?.id;

	return (
		rowData?.record_type === 'payment' &&
		rowData?.paid_to !== undefined &&
		rowData?.paid_to !== null &&
		recipientEntityId !== undefined &&
		recipientEntityId !== null &&
		String(rowData.paid_to) === String(recipientEntityId)
	);
};

const PaymentSummaryId = ({ field, rowData, profile }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const selectedSubModule = useSelector(selectSelectedSubModule);
	const isInvoice = resolvePaymentOrderInvoiceContext({
		selectedSubModule,
		payloadIsInvoice: false,
	});
	const canOpenSummary =
		isPaymentSummaryRow(rowData, profile) &&
		canOpenContractorPaymentSummary({ profile, isInvoice });

	if (!canOpenSummary)
		return <OnlyReadField rowData={rowData} field={field} profile={profile} />;

	const handleOpenSummary = event => {
		event.stopPropagation();
		const elementViewKeys =
			ElementViewBuilderConfig.getAuthorizedElementViewKeys();

		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: rowData.paycut_id || rowData.id,
			paycutId: rowData.paycut_id,
			isInvoice,
			drawerConfig: {
				maxWidth: '50vw',
				fullWidthBelow: '768px',
				noOverflow: true,
			},
			initialView: {
				tabKey: 'summaryKey',
				summaryOnly: true,
				readOnly: true,
				titleTab: rowData.payment_name || `Cobro #${rowData.id}`,
				fechtData: {
					paymentId: rowData.id,
					paycutId: rowData.paycut_id,
					paid_to: rowData.paid_to,
					coinId: rowData.coin_id,
					coinSymbol: rowData.coin_symbol,
					paymentName: rowData.payment_name,
				},
			},
		});
	};

	return (
		<SummaryButton
			type='button'
			onClick={handleOpenSummary}
			aria-label={`Abrir resumen del cobro ${rowData.id}`}
		>
			{rowData[field.id]}
		</SummaryButton>
	);
};

export default PaymentSummaryId;
